var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"first"},[_c('Banner'),_c('div',[_c('div',{staticClass:"classic-case"},[_c('ClassicCase')],1),_c('div',{staticClass:"excellent-cases"},[_c('ExcellentCases')],1),_c('div',{staticClass:"classic-customer"},[_c('ClassicCustomer')],1),_c('div',{staticClass:"excellent-service"},[_c('ExcellentService')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }